module.exports = __webpack_public_path__ + "static/feature-mute-c93a3de2f01bb423c6dffdeb5ef9ecd2.png";